import React from "react";
import "./NavigationDots.scss";
const NavData = ["home", "about", "work", "skills", "testimonial", "contact"];
const NavigationDots = ({ active }) => {
  return (
    <div className="app__navigation">
      {NavData.map((item, i) => (
        <a
          href={`#${item}`}
          key={item + i}
          className="app__navigation-dot"
          style={active === item ? { backgroundColor: "#313BAC" } : {}}
        />
      ))}
    </div>
  );
};

export default NavigationDots;
